import React, { memo, useContext, useMemo, useState } from 'react';
import classNames from 'classnames';

import LeafHeader from './leafHeader';
import LeafContent from './leafContent';
import configCtx from '../../services/context.service';
import { contentSourceHasText } from '@modules/projects/projectDetail/lifeCycle/components/helper';

const TreeLeaf = ({
  data,
  actionDisable,
  leafOrder,
  containerOrder,
  containerId,
  formChange = () => {},
}) => {
  const {
    changeTreeDataCollection,
    changeCollapsedIds,
    collapsedIds,
    isAllEditing,
    isAllExpanding,
    idLocations,
    editingId,
    setEditingId,
    setActiveId,
    activeId,
    handleDeleteNode,
  } = useContext(configCtx);

  const [isFocused, toggleIsFocused] = useState(false);
  const { id, richContent, htmlContent, order, title } = data;
  const [isClosing, toggleIsClosing] = useState(false);
  const location = idLocations.get(id) || [containerOrder, leafOrder - 1];

  const isEditing = editingId === id || isAllEditing;
  const isExpand = isEditing || isAllExpanding || !collapsedIds.includes(id);

  const isActive = id === activeId;
  const className = classNames('lifecycle-content', {
    'expanded-content': isExpand,
    'is-focus': isFocused,
    'is-active': isActive,
    'close-animation': isClosing,
  });

  const hasLeafContent = useMemo(
    () => contentSourceHasText(richContent?.contentSource),
    [richContent?.contentSource],
  );
  const showLeftContent = isEditing || hasLeafContent;

  const handleToggleExpand = (e) => {
    if (!(title && hasLeafContent)) {
      return;
    }
    e.stopPropagation();
    if (actionDisable) {
      return;
    }

    if (isExpand) {
      toggleIsClosing(true);
      setTimeout(() => {
        changeCollapsedIds(id);
        toggleIsClosing(false);
      }, 500);
    } else {
      changeCollapsedIds(id);
    }
  };

  return (
    <>
      <div
        className={className}
        onFocus={() => toggleIsFocused(true)}
        onBlur={() => toggleIsFocused(false)}
        onClick={() => {
          setActiveId(containerId);
        }}
      >
        <LeafHeader
          title={title}
          isExpand={isExpand}
          isEditing={isEditing}
          onExpand={handleToggleExpand}
          order={order}
          upDateCollection={changeTreeDataCollection}
          location={location}
          handleDelete={() => handleDeleteNode(containerId, leafOrder - 1, id)}
          hasArrow={showLeftContent && title}
          formChange={formChange}
        />
        {showLeftContent ? (
          <LeafContent
            updateDataCollection={changeTreeDataCollection}
            isExpand={isExpand || !title}
            isEditing={isEditing}
            contentSource={richContent?.contentSource}
            config={richContent?.config}
            htmlContent={htmlContent}
            location={location}
            order={order}
            setEditingId={() => setEditingId(id)}
            noTitle={!title && !isEditing}
            formChange={formChange}
          />
        ) : null}
      </div>
    </>
  );
};

export default memo(TreeLeaf);
